import { useStopWatchCountDown } from "global-components-library";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { setNewPreviewTime } from "../../../redux/actions/A_preview";
import { USER_STATE } from "../../../constants";

const StopWatchPreview = ({ hours, minutes, secondsInitial, isRunning, onTimeOver,isTimeAscending, userState=USER_STATE.READY_PREVIEW}) => {
  let { start, stop, fullFormat, seconds } = useStopWatchCountDown(hours, minutes, secondsInitial,1000,isTimeAscending);
  const [complete, setComplete] = useState("00:00:00");
  const [timeOver,setTimeOver] = useState(false);
  const isRunningClock = useSelector(state => state.preview.isRunningClock);
  const dispatch = useDispatch();

  const stringToSec = (result) => {
    let string= result.split(":");
    let intMin = parseInt(string[1]);
    let intSec = parseInt(string[2]);
    let newTime = intMin * 60 + intSec;
    dispatch(setNewPreviewTime(newTime));
  }

  
  useEffect(() => {
    start();
    if(timeOver || !isRunning)
    {
      stop();
    }
    return () => {
      stop();
    }
  }, [timeOver,isRunning]);

  useEffect(() => {
    let result = fullFormat();
    setComplete(result);
    if(result === "00:00:00" && !isTimeAscending)
    {
      onTimeOver();
      dispatch(setNewPreviewTime(0)); //Limpiar tiempo
      setTimeOver(true);
    }
    (!isRunningClock && userState !== USER_STATE.WRAPUP) && (stringToSec(result));
  }, [seconds,isRunningClock]);

  return complete;
};

export default StopWatchPreview;



// WEBPACK FOOTER //
// ./src/components/Header/StopWatch/StopWatchPreview.jsx